import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface JasperHeaderSearchProps {
    searchString: string;
}
const initialState: JasperHeaderSearchProps = {
    searchString: '',
};
const JasperHeaderSearchSlice = createSlice({
    name: 'JasperHeaderSearch',
    initialState,
    reducers: {
        setJasperHeaderSearch: (state, action: PayloadAction<string>) => {
            state.searchString = action.payload;
        },
    },
});

export const { setJasperHeaderSearch } = JasperHeaderSearchSlice.actions;
export default JasperHeaderSearchSlice.reducer;
